import React from "react";
import { faUser, faChevronDown, faChevronUp, } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row, useClasses } from "../../";
const styles = (theme) => ({
    wrapper: {
        display: "inline-block",
    },
    btn: {
        border: "0px",
        borderRadius: "40px",
        outline: "none",
        backgroundColor: "rgba(0, 0, 0, 0)",
        padding: "0px 0px",
        textAlign: "left",
        color: theme.palette.get("font"),
        fontFamily: '"Noto Sans", sans-serif',
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.get("grey"),
        },
    },
    thumbPlaceholder: {
        backgroundColor: theme.palette.get("formBackground"),
        color: theme.palette.get("formLabel"),
        fontSize: "1.5rem",
        width: "40px",
        height: "40px",
        display: "inline-block",
        borderRadius: "100%",
        padding: "5px 11px",
        boxSizing: "border-box",
    },
    name: {
        marginTop: "1px",
        fontWeight: 600,
    },
    team: {
        fontSize: "0.9rem",
    },
    content: {
        maxWidth: "150px",
        overflow: "hidden",
        marginTop: "5px",
        display: "inline-block",
        lineHeight: "1.1rem",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    chevron: {
        marginTop: "13px",
    },
});
export default function Widget(props) {
    const classes = useClasses(styles);
    const { user, open, onChange } = props;
    return (React.createElement("button", { className: classes.btn, onClick: (e) => {
            e.preventDefault();
            onChange();
        } },
        React.createElement(Row, { spacing: 8, root: { left: 0 } },
            React.createElement(Col, { xs: "40px" },
                React.createElement("div", { className: classes.thumbPlaceholder },
                    React.createElement(FontAwesomeIcon, { icon: faUser }))),
            React.createElement(Col, { xs: "auto" },
                React.createElement("div", { className: classes.content },
                    React.createElement("span", { className: classes.name },
                        user.firstname,
                        " ",
                        user.lastname),
                    React.createElement("br", null),
                    React.createElement("span", { className: classes.team }, user.currentTeamName ? "@" + user.currentTeamName : "-"))),
            React.createElement(Col, { xs: "auto" },
                !open && (React.createElement(FontAwesomeIcon, { className: classes.chevron, icon: faChevronDown })),
                open && (React.createElement(FontAwesomeIcon, { className: classes.chevron, icon: faChevronUp }))))));
}
